"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DramaticEndingsEffectHandler = exports.DramaticEndingsEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DramaticEndingsEffectArgs {
    constructor(regenAmount, powerAmount) {
        this.regenAmount = regenAmount;
        this.powerAmount = powerAmount;
        this.__type = EffectType_1.EffectType.DramaticEndings;
        this.__typeName = "DramaticEndings";
        this.name = "Dramatic Endings";
        this.harmful = false;
    }
}
exports.DramaticEndingsEffectArgs = DramaticEndingsEffectArgs;
let DramaticEndingsEffectHandler = class DramaticEndingsEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.RegenerationEffectArgs("DramaticEndings", state.args.regenAmount),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Power, state.args.powerAmount),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds.forEach(id => container.cancelEffect(sequence, id));
    }
};
DramaticEndingsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DramaticEndings)
], DramaticEndingsEffectHandler);
exports.DramaticEndingsEffectHandler = DramaticEndingsEffectHandler;
